/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use, useEffect } from 'fierry/react';

import State from 'solis/time/state';


export default () =>
{
  const dispatch = use(State.Dispatch);

  const effectCallback = () =>
  {
    const interval = window.setInterval(() => dispatch.refresh(), 1000);

    return () =>
    {
      window.clearInterval(interval);
    }
  };

  return useEffect(effectCallback, []);
};
